import { useMemo } from "react";
import { dayOfWeeks } from "../../../../../../../../components/weekDayPicker/constants";
import { PeriodType, type SessionView } from "../../../../../types/state";
import DescriptionBuilderProvider from "../../../Utils/descriptionBuilderProvider";
import eventSessionUtils from "../../../../../../../../utils/eventSessionUtils";
import moment from "moment/moment";
import { isUndefined } from "lodash";

export interface RecurringSessionDescriptionProps {
  session: SessionView;
}

export const RecurringSessionDescription = (props: RecurringSessionDescriptionProps) => {
  const { recurrenceSession, startsAt, endsAt, timeZone, startDate } = props.session;
  const { seriesEndDate, periodValue, periodicRule, weekDays } = recurrenceSession || {};

  const periodType = recurrenceSession?.periodType ?? PeriodType.Day;

  const optionsMap = useMemo(() => {
    return eventSessionUtils.getRadioOptions(moment.utc(startDate), periodType);
  }, [periodType, startDate]);

  return useMemo(() => {
    const builder = DescriptionBuilderProvider.createDescriptionBuilder();
    builder
      .occursOn(!isUndefined(periodicRule) ? optionsMap[periodicRule] : "")
      .endingOn(seriesEndDate)
      .startingAt(startsAt)
      .endingAt(endsAt)
      .usingTimeZone(timeZone)
      .usingPeriod(periodType ?? PeriodType.Day)
      .withRepetition(periodValue ?? 1)
      .onWeekDays(weekDays?.map((x) => dayOfWeeks[x]));
    return builder.getDescription();
  }, [optionsMap, seriesEndDate, startsAt, endsAt, timeZone, periodType, periodValue, weekDays, periodicRule]);
};
